import { z } from "zod";

export const languageSchema = z.object({
  code: z.string(),
  title: z.string(),
});

export type Language = z.infer<typeof languageSchema>;
